module.exports = __webpack_public_path__ + "static/media/person-3-full.cd8fe51d.png";